import { TaskType } from 'src/app/shared/enums/task-type-enum';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { FetchPropertyRecordsTask } from 'src/app/shared/models/fetch-property-records-task';
import { Task } from 'src/app/shared/models/task';

export function tasksFactory(taskData: ZoningAPI.ITask): ITaskModel {
    switch (taskData.type) {
        case TaskType.NONE:
            return new Task(taskData);
        case TaskType.ZONING_CODE_INDEXING:
        case TaskType.ZONING_CODE_INDEXING_WITH_CURSOR:
            return new FetchPropertyRecordsTask(taskData);
        default:
            return new Task(taskData);
    }
}
